import { defineStore } from "pinia";
import { authStore } from "../index";
import { SearchFilter } from "@/models/queryBuilder";
import axios from "axios";
export const useApiStore = defineStore("api", () => {
    const axiosInstance = () => {
        const auth = authStore();
        const authHeader = `${auth.user.id_token}`;
        const axiosInstance = axios.create({
            baseURL: process.env.VUE_APP_CUBE_BASE_URL,
            headers: {
                common: {
                    Authorization: authHeader,
                },
            },
        });

        axiosInstance.interceptors.request.use((request) => {
            request.transformResponse = [(data) => data];
            return request;
        });
        axiosInstance.interceptors.response.use(
            (response) => {
                return response;
            },
            (error) => {
                return error;
            }
        );
        return axiosInstance;
    };

    const handleError = (error: any) => {
        console.error(error);
        return Promise.reject(error);
    };

    const delay = (delayInms: number) => {
        return new Promise(resolve => setTimeout(resolve, delayInms));
    };

    const fetchMainTable = async (query: any) => {
        try {
            let value: any = {}
            for (let count = 0; count < 3; count++) {
                value = await axiosInstance().get("/load?query=" + JSON.stringify(query));
                if (!JSON.stringify(value).includes("Continue wait") && !(value.name && value.name == "AxiosError")) {
                    const response = removeCount(JSON.parse(value.data).data, "plays.count");
                    const data = [response, JSON.parse(value.data).total]
                    return data;
                }
                await delay(Math.pow(60, count));
            }
            const error = value.name == "AxiosError" ? Error(JSON.parse(value.response.data).message) : Error(JSON.parse(value.data).error)
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            error.code = 503
            throw error;
        } catch (error: any) {
            if (error.message == "Continue wait" || error.message == "Service Unavailable") {
                console.log(error)
                return error;
            }
            return handleError(error);
        }
    };

    const fetchBattersList = async () => {
        try {
            let response = null;
            await axiosInstance().get(
                "/load?query=" +
                JSON.stringify({
                    dimensions: ["striker.player_id", "striker.display_name"],
                    measures: ["plays.count"],
                    order: [[
                        "striker.display_name",
                        "asc"
                    ]],
                    filters: [
                        {
                            member: "striker.player_id",
                            operator: "notEquals",
                            values: ["0"],
                        },
                        { member: "striker.player_id", operator: "set" },
                    ],
                    offset: 0,
                })
            ).then((value: any) => {
                if (value.name && value.name == "AxiosError") {
                    const error = Error(JSON.parse(value.response.data).message)
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    error.code = 503
                    throw error;
                }
                response = removeCount(JSON.parse(value.data).data, "plays.count");
            });
            return response;
        } catch (error: any) {
            if (error.message == "Service Unavailable") {
                console.log(error)
                return error;
            }
            return handleError(error);
        }
    };
    const fetchBattersListWithFilters = async (filters: SearchFilter[]) => {
        try {
            let response = null;
            await axiosInstance()
                .get(
                    "/load?query=" +
                    JSON.stringify({
                        dimensions: ["striker.player_id", "striker.display_name"],
                        measures: ["plays.count"],
                        order: [[
                            "striker.display_name",
                            "asc"
                        ]],
                        filters: filters,
                        offset: 0,
                    })
                )
                .then((value) => {
                    response = removeCount(JSON.parse(value.data).data, "plays.count");
                });
            return response;
        } catch (error) {
            return handleError(error);
        }
    };

    const fetchBowlersList = async () => {
        try {
            let response = null;
            await axiosInstance().get(
                "/load?query=" +
                JSON.stringify({
                    dimensions: ["bowler.player_id", "bowler.display_name"],
                    measures: ["plays.count"],
                    order: [[
                        "bowler.display_name",
                        "asc"
                    ]],
                    filters: [
                        {
                            member: "bowler.player_id",
                            operator: "notEquals",
                            values: ["0"],
                        },
                        { member: "bowler.player_id", operator: "set" },
                    ],
                    offset: 0,
                })
            ).then((value: any) => {
                if (value.name && value.name == "AxiosError") {
                    const error = Error(JSON.parse(value.response.data).message)
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    error.code = value.response.status
                    throw error;
                }
                response = removeCount(JSON.parse(value.data).data, "plays.count");
            });
            return response;
        } catch (error: any) {
            if (error.message == "Service Unavailable") {
                console.log(error)
                return error;
            }
            return handleError(error);
        }
    };
    const fetchBowlersListWithFilters = async (filters: SearchFilter[]) => {
        try {
            let response = null;
            await axiosInstance()
                .get(
                    "/load?query=" +
                    JSON.stringify({
                        dimensions: ["bowler.player_id", "bowler.display_name"],
                        measures: ["plays.count"],
                        order: [[
                            "bowler.display_name",
                            "asc"
                        ]],
                        filters: filters,
                        offset: 0,
                    })
                )
                .then((value) => {
                    response = removeCount(JSON.parse(value.data).data, "plays.count");
                });
            return response;
        } catch (error) {
            return handleError(error);
        }
    };
    const fetchPlayersFromTeamList = async (teamName: string) => {
        try {
            let response = null;
            await axiosInstance().get(
                "/load?query=" +
                JSON.stringify({
                    dimensions: [
                        "players.player_id",
                        "players.display_name",
                        "players.country",
                        "players.bowl_style",
                        "players.bat_hand",
                    ],
                    measures: ["players.count"],
                    order: [[
                        "players.display_name",
                        "asc"
                    ]],
                    filters: [
                        {
                            member: "players.player_id",
                            operator: "notEquals",
                            values: ["0"],
                        },
                        { member: "players.player_id", operator: "set" },
                        {
                            "member": "players.team",
                            "operator": "equals",
                            "values": [
                                teamName
                            ]
                        }
                    ],
                    offset: 0,
                })
            ).then((value) => {
                response = removeCount(JSON.parse(value.data).data, "players.count");
            });
            return response
        } catch (error) {
            return handleError(error);
        }
    };
    const fetchPlayersList = async () => {
        try {
            let response = null;
            await axiosInstance().get(
                "/load?query=" +
                JSON.stringify({
                    dimensions: [
                        "players.player_id",
                        "players.display_name",
                        "players.country",
                        "players.bowl_style",
                        "players.bat_hand",
                    ],
                    measures: ["players.count"],
                    order: [[
                        "players.display_name",
                        "asc"
                    ]],
                    filters: [
                        {
                            member: "players.player_id",
                            operator: "notEquals",
                            values: ["0"],
                        },
                        { member: "players.player_id", operator: "set" },
                    ],
                    offset: 0,
                })
            ).then((value: any) => {
                if (value.name && value.name == "AxiosError") {
                    const error = Error(JSON.parse(value.response.data).message)
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    error.code = value.response.status
                    throw error;
                }
                response = removeCount(JSON.parse(value.data).data, "plays.count");
            });
            return response;
        } catch (error: any) {
            if (error.message == "Service Unavailable") {
                console.log(error)
                return error;
            }
            return handleError(error);
        }
    };
    const fetchVenueList = async () => {
        try {
            let response = null;
            await axiosInstance()
                .get(
                    "/load?query=" +
                    JSON.stringify({
                        dimensions: [
                            "venues.venue_id",
                            "venues.stadium",
                            "venues.city",
                            "venues.state",
                            "venues.country",
                        ],
                        measures: ["venues.count"],
                        order: [[
                            "venues.stadium",
                            "asc"
                        ]],
                        filters: [
                            {
                                member: "venues.venue_id",
                                operator: "notEquals",
                                values: ["0"],
                            },
                            { member: "venues.venue_id", operator: "set" },
                        ],
                        offset: 0,
                    })
                ).then((value: any) => {
                    if (value.name && value.name == "AxiosError") {
                        const error = Error(JSON.parse(value.response.data).message)
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        error.code = value.response.status
                        throw error;
                    }
                    response = removeCount(JSON.parse(value.data).data, "plays.count");
                });
                return response;
            } catch (error: any) {
                if (error.message == "Service Unavailable") {
                    console.log(error)
                    return error;
                }
                return handleError(error);
        }
    };
    const fetchVenuesListWithFilters = async (filters: SearchFilter[]) => {
        try {
            let response = null;
            await axiosInstance()
                .get(
                    "/load?query=" +
                    JSON.stringify({
                        dimensions: [
                            "venues.venue_id",
                            "venues.stadium",
                            "venues.city",
                            "venues.state",
                            "venues.country",
                        ],
                        measures: ["plays.count"],
                        order: [[
                            "venues.stadium",
                            "asc"
                        ]],
                        filters: filters,
                        offset: 0,
                    })
                )
                .then((value) => {
                    response = removeCount(JSON.parse(value.data).data, "plays.count");
                });
            return response;
        } catch (error) {
            return handleError(error);
        }
    };
    const fetchTeamList = async () => {
        try {
            return await axiosInstance().get(
                "/load?query=" +
                JSON.stringify({
                    dimensions: ["teams.team_id", "teams.name", "teams.country"],
                    order: [[
                        "teams.name",
                        "asc"
                    ]],
                    filters: [
                        { member: "teams.team_id", operator: "notEquals", values: ["0"] },
                        { member: "teams.team_id", operator: "set" },
                    ],
                    offset: 0,
                })
            );
        } catch (error) {
            return handleError(error);
        }
    };
    const fetchMatchList = async () => {
        try {
            return await axiosInstance().get(
                "/load?query=" +
                JSON.stringify({
                    dimensions: ["matches.match_id", "matches.name", "matches.start_date", "matches.series"],
                    order: [
                        [
                            "matches.start_date",
                            "desc"
                        ]
                    ],
                    filters: [
                        { member: "matches.match_id", operator: "notEquals", values: ["0"] },
                        { member: "matches.match_id", operator: "set" },
                    ],
                    offset: 0,
                })
            );
        } catch (error) {
            return handleError(error);
        }
    };
    const fetchMacthFromMatchId = async (matchId: string) => {
        try {
            let response = null;
            await axiosInstance().get(
                "/load?query=" +
                JSON.stringify({
                    dimensions: [
                        "matches.match_id",
                        "matches.name",
                        "matches.match_type",
                        "matches.start_date",
                        "matches.series",
                        "matches.day_nighter",
                    ],
                    measures: ["matches.count"],
                    order: {},
                    filters: [
                        { member: "matches.match_id", operator: "notEquals", values: ["0"] },
                        { member: "matches.match_id", operator: "set" },
                        {
                            "member": "matches.match_id",
                            "operator": "equals",
                            "values": [
                                matchId
                            ]
                        }
                    ],
                    offset: 0,
                })
            ).then((value) => {
                response = removeCount(JSON.parse(value.data).data, "matches.count");
            });
            return response
        } catch (error) {
            return handleError(error);
        }
    };
    const fetchSeriesList = async () => {
        try {
            return await axiosInstance().get(
                "/load?query=" +
                JSON.stringify({
                    dimensions: ["matches.series"],
                    order: [],
                    filters: [
                        { member: "matches.series", operator: "notEquals", values: ["0"] },
                        { member: "matches.series", operator: "set" },
                    ],
                    offset: 0,
                })
            );
        } catch (error) {
            return handleError(error);
        }
    };
    const fetchMatchTypeList = async () => {
        try {
            return await axiosInstance().get(
                "/load?query=" +
                JSON.stringify({
                    dimensions: ["matches.match_type"],
                    order: [],
                    filters: [
                        { member: "matches.match_type", operator: "notEquals", values: ["0"] },
                        { member: "matches.match_type", operator: "set" },
                    ],
                    offset: 0,
                })
            );
        } catch (error) {
            return handleError(error);
        }
    };
    const queryGeneric = async (query: any) => {
        try {
            let response = await axiosInstance().get(
                "/load?query=" + JSON.stringify(query)
            );
            let count = 0;
            while (
                Object.values(JSON.parse(response.data)).includes("Continue wait")
            ) {
                if (count > 1) {
                    throw new Error("A network error occurred");
                }
                response = await axiosInstance().get(
                    "/load?query=" + JSON.stringify(query)
                );
                count = count + 1;
            }
            return response;
        } catch (error) {
            return handleError(error);
        }
    };

    return {
        queryGeneric,
        fetchVenueList,
        fetchBowlersList,
        fetchBattersList,
        fetchPlayersList,
        fetchTeamList,
        fetchMatchList,
        fetchBowlersListWithFilters,
        fetchVenuesListWithFilters,
        fetchBattersListWithFilters,
        fetchMainTable,
        fetchSeriesList,
        fetchMatchTypeList,
        fetchPlayersFromTeamList,
        fetchMacthFromMatchId,
    };
});

function removeCount(data: [], countKey: string): [] {
    data.forEach((element) => {
        delete element[countKey];
    });
    return data;
}
